import { Grid, TextField, Button } from "@mui/material";
import CommonAutocomplete from "../../components/CommonAutocomplete";
import { getBuyer } from "../../http/api/BuyerAPI";
import { useEffect, useState } from "react";
import useInputObject from "../../hooks/useInputObject";
import { PRICE_DETAIL_TYPE } from "../../common/const";
import { delay } from "../../utils/utils";
import { MODAL_STATE } from "./ChainStoreUtils";

const infoTableCellSx = {
  fontSize: 17,
  m: 2,
  width: 200,
};
const HEADER_ELEMENT_COUNT = 5;

function handlePressKey(event) {
  if (event.key === "Enter") {
    // 左Enter
    if (event.location === 0) {
      event.preventDefault();
      let firstSalesDetail = document.getElementById(`productItem-0-0`);
      if (firstSalesDetail) firstSalesDetail.focus();
    }
    // 右Enter
    if (event.location === 3) {
      event.preventDefault();
      focusNavigation(event.target, event.shiftKey);
    }
  }
}

function handleKeyDown(event) {
  const keyCode = event.keyCode;
  //Arrow Key
  if (keyCode === 37) {
    // Handle left arrow key press
    focusNavigation(event.target, true);
  } else if (keyCode === 38) {
    // Handle up arrow key press
  } else if (keyCode === 39) {
    // Handle right arrow key press
    focusNavigation(event.target, false);
  }
}

function focusNavigation(currentElement, isPrevious = false) {
  const focusing = currentElement.id;
  const nextStep = isPrevious ? -1 : 1;
  const nextIndex = parseInt(focusing.split("-")[1], 10) + nextStep;
  const district = nextIndex < HEADER_ELEMENT_COUNT ? "header" : "productItem";
  let shortcut = {
    district: district,
    index: nextIndex < HEADER_ELEMENT_COUNT ? nextIndex : "0-0",
  };
  setTimeout(() => {
    let nextElement = document.getElementById(
      `${shortcut.district}-${shortcut.index}`
    );
    if (nextElement) {
      nextElement.focus();
    } else {
    }
  }, 0);
}

function handleFocus(event) {
  event.target.select();
}
const Header = (props) => {
  const { header: headerAPI, modalState } = props;
  const [buyers, setBuyers] = useState([]);
  const [buyer, setBuyer] = useState();
  const header = useInputObject(headerAPI.Value);

  useEffect(() => {
    const newBuyer = buyers.find((x) => x.buyerNo === header.Value?.buyerNo);
    setBuyer(newBuyer);
  }, [header.Value.buyerNo]);

  useEffect(() => {
    header.setValue(headerAPI.Value);
  }, [headerAPI.Value]);

  useEffect(() => {
    header.update("buyerNo", buyer?.buyerNo || "");
    headerAPI.update("buyerNo", buyer?.buyerNo || "");
  }, [buyer]);

  async function GetBuyers() {
    let response = await getBuyer({});
    let listInfo = response.listBuyerInfo;
    listInfo = listInfo.map((o) => ({
      buyerNo: o.buyerNo,
      buyerName: o.buyerName,
    }));
    setBuyers(listInfo);
  }
  useEffect(() => {
    GetBuyers();
  }, []);
  function handleBlur() {
    headerAPI.setValue(header.Value);
  }

  function handleChooseType(type) {
    headerAPI.update("priceDetailTypeId", type);
  }

  return (
    <Grid>
      <Grid
        container
        onKeyPress={handlePressKey}
        onKeyDown={handleKeyDown}
        onFocus={handleFocus}
        display="flex"
        justifyContent="space-between"
        onBlur={handleBlur}
      >
        <Grid item xs={9} display="flex">
          <TextField
            InputLabelProps={{
              shrink: true,
            }}
            InputProps={{
              paddingInline: 0,
              inputProps: {
                min: "1000-01-01",
                max: "9999-12-31",
              },
            }}
            label="日付"
            type="date"
            id={`header-0`}
            value={header.Value.shipmentDate}
            onChange={(e) => header.update("shipmentDate", e.target.value)}
            sx={infoTableCellSx}
          ></TextField>

          <CommonAutocomplete
            label="得意先"
            value={buyer || null}
            onSelect={(e, newValue) => {
              setBuyer(newValue);
              focusNavigation(document.activeElement, false);
            }}
            name="buyerNo"
            id={`header-1`}
            data={buyers}
            filterOptions={(options, { inputValue }) => {
              inputValue = inputValue.trim();
              return options.filter((x) => {
                return (
                  x.buyerNo.toString().includes(inputValue) ||
                  x.buyerName.includes(inputValue)
                );
              });
            }}
            optionLabel={(option) =>
              option ? option.buyerNo + " - " + option.buyerName : ""
            }
            sx={{ ...infoTableCellSx, width: 350 }}
          />
          <TextField
            InputLabelProps={{
              shrink: true,
            }}
            InputProps={{
              paddingInline: 0,
            }}
            label="分類No"
            type="number"
            id={`header-2`}
            value={header.Value.classNo || ""}
            onChange={(e) => header.update("classNo", e.target.value)}
            sx={infoTableCellSx}
          ></TextField>
          <TextField
            InputLabelProps={{
              shrink: true,
            }}
            InputProps={{
              paddingInline: 0,
            }}
            label="区分"
            type="number"
            id={`header-3`}
            value={header.Value.division || ""}
            onChange={(e) => header.update("division", e.target.value)}
            sx={infoTableCellSx}
          ></TextField>
        </Grid>
        <Grid item xs={3} display="flex" justifyContent="flex-end">
          <TextField
            InputLabelProps={{
              shrink: true,
            }}
            InputProps={{
              paddingInline: 0,
            }}
            label="番号"
            type="number"
            id={`header-4`}
            value={header.Value.slipNo || ""}
            onChange={(e) => header.update("slipNo", e.target.value)}
            sx={infoTableCellSx}
          ></TextField>
        </Grid>
      </Grid>
      <Grid container display="flex">
        <Grid xs={8}>
          <Button
            variant="contained"
            color="primary"
            onClick={(e) => {
              handleChooseType(PRICE_DETAIL_TYPE.VEGETABLE);
            }}
            id="getOrderDataVegetableButton"
            sx={{ marginLeft: 2 }}
          >
            蔬菜
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={(e) => {
              handleChooseType(PRICE_DETAIL_TYPE.FLUIT);
            }}
            id="getOrderDataFluitButton"
            sx={{ marginLeft: 2 }}
          >
            果物
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={(e) => {
              handleChooseType(PRICE_DETAIL_TYPE.ELSE);
            }}
            id="getOrderDataElseButton"
            sx={{ marginLeft: 2 }}
          >
            その他
          </Button>
          <Button
            variant="contained"
            color="warning"
            onClick={(e) => {
              handleChooseType(PRICE_DETAIL_TYPE.CLEAR);
            }}
            id="clearDetailsButton"
            sx={{ marginLeft: 4 }}
          >
            クリア
          </Button>
        </Grid>
        <Grid xs={4} display="flex" justifyContent="flex-end">
          <Button
            variant="contained"
            color="primary"
            onClick={(e) => {
              modalState.updates({
                open: true,
                mode: MODAL_STATE.INSERT,
                isAlien: true,
              });
            }}
            id="insertChainStoreProductButton"
            sx={{ marginRight: 2 }}
          >
            チェーンストア商品登録
          </Button>
        </Grid>
      </Grid>
    </Grid>
  );
};
export default Header;
